// extracted by mini-css-extract-plugin
export default {"loading":"SmallPreloader_loading"};